import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { BodyS } from '#src/atoms/typography/index.tsx';

const ButtonsBar = styled.div`
  display: flex;
  gap: var(--double-unit);
  flex-wrap: wrap;
`;
const StyledButtonBase = styled(ButtonBase)`
  color: var(--c-link);
  text-decoration: underline;
`;

export const PhoneNumberVerificationButton = ({
  message,
  onClick,
}: {
  message: MessageDescriptor;
  onClick: () => void;
}) => {
  return (
    <ButtonsBar>
      <StyledButtonBase onClick={onClick} color="var(--c-link)">
        <BodyS bold>
          <FormattedMessage {...message} />
        </BodyS>
      </StyledButtonBase>
    </ButtonsBar>
  );
};
